import { memoizedGroupBySelector } from '@travelnest/entities';

import { INotification } from '.';
import { IState } from '../../../store/reducer';

type NotificationsById = IState['data']['notifications']['byId'];

export const active = (state: NotificationsById, customer: string) => {
	const all = memoizedGroupBySelector('recipient', state)[customer];
	return (all || []).filter((a) => a.is_active);
};

export const grouped = (notifications: INotification[]): { [key: string]: INotification[] } => {
	return notifications.reduce((group, n) => {
		let key = n.notification_type;
		const context = n.content.context || {};

		if (context.hasOwnProperty('property')) {
			key = `${key}_property_${context.property.id}`;
		} else if (context.hasOwnProperty('customer')) {
			key = `${key}_customer_${context.customer.id}`;
		}
		group[key] = group[key] || [];
		group[key].push(n);
		return group;
	}, {});
};

export const deduped = (notifications: INotification[]) => {
	return Object.values(grouped(notifications)).map((notifs) => ({ count: notifs.length, notification: notifs[0] }));
};
